import { trigger, transition, style, query, animate, group } from '@angular/animations';

export const routeAnimations = trigger('routeAnimations', [
    transition('* => DetailsPage', [
        // Initial setup for the pages
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),

        group([
            // Leaving page slides out to the left
            query(
                ':leave',
                [
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(-100%)',
                            opacity: 0.5,
                        })
                    ),
                ],
                { optional: true }
            ),

            // Entering page slides in from the right
            query(
                ':enter',
                [
                    style({
                        transform: 'translateX(100%)',
                        opacity: 0,
                    }),
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(0)',
                            opacity: 1,
                        })
                    ),
                ],
                { optional: true }
            ),
        ]),
    ]),
    transition('* => DetailsPage', [
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),

        group([
            // Leaving page slides out to the left
            query(
                ':leave',
                [
                    style({
                        transform: 'translateX(0)',
                        opacity: 1,
                    }),
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(-100%)',
                            opacity: 0,
                        })
                    ),
                ],
                { optional: true }
            ),

            // Entering page slides in from the right
            query(
                ':enter',
                [
                    style({
                        transform: 'translateX(100%)',
                        opacity: 0,
                    }),
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(0)',
                            opacity: 1,
                        })
                    ),
                ],
                { optional: true }
            ),
        ]),
    ]),

    // Transition back to the previous page (DetailsPage => *)
    transition('DetailsPage => *', [
        query(':enter, :leave', style({ position: 'absolute', width: '100%' }), { optional: true }),

        group([
            // Leaving page slides out to the right
            query(
                ':leave',
                [
                    style({
                        transform: 'translateX(0)',
                        opacity: 1,
                    }),
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(100%)',
                            opacity: 0,
                        })
                    ),
                ],
                { optional: true }
            ),

            // Entering page slides in from the left
            query(
                ':enter',
                [
                    style({
                        transform: 'translateX(-100%)',
                        opacity: 0,
                    }),
                    animate(
                        '0.5s ease-in-out',
                        style({
                            transform: 'translateX(0)',
                            opacity: 1,
                        })
                    ),
                ],
                { optional: true }
            ),
        ]),
    ]),
]);
